import React from "react";
import { useLocation } from "react-router-dom";
import "../styles/Header.css";

const Header = () => {
  const location = useLocation();
  const isRegistrationPage = location.pathname.includes("homam-registration");

  return (
    <header className={`header ${isRegistrationPage ? "header-compact" : ""}`}>

      <div className={`container header-container ${isRegistrationPage ? "header-container-compact" : ""}`}>

        {/* Logo */}
        <div className={`logo ${isRegistrationPage ? "logo-compact" : ""}`}>
          <img src="/images/sailogo.png" alt="Sai Baba Logo" />
        </div>

        {/* Title */}
        <div className="title-section">

          <h1 className={`title ${isRegistrationPage ? "title-compact" : ""}`}>
            SRI GNANA SAI BABA MANDIR
          </h1>

          <p className={`subtitle ${isRegistrationPage ? "subtitle-compact" : ""}`}>
            A Place Where Faith Becomes Reality
          </p>

        </div>

      </div>

    </header>
  );
};

export default Header;